import 'lazysizes';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.to(".scroll-down", {
    scrollTrigger: {
        trigger: "#top",
        start: "60px top",
        //markers: true
    },
    opacity: 0
});

gsap.to(".scroll-icon", {
    scrollTrigger: {
        trigger: ".scroll-icon",
        scrub: 2,
        start: "top 90%",
        end: "bottom 40%",
        //markers: true
    },
    rotate: 360
});

gsap.to(".scroll-icon-1", {
    scrollTrigger: {
        trigger: ".scroll-icon-1",
        scrub: 2,
        start: "top 90%",
        end: "bottom 40%",
        //markers: true
    },
    rotate: 360
});
